import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TableDataType } from '@app/shared/enums/common.enums';
import { TimelineHistoryData } from '@app/shared/models/common.model';
import { StatusMeta } from '@app/shared/utilities/status.meta';

@Component({
  selector: 'app-timeline-history-dialog',
  templateUrl: './timeline-history-dialog.component.html',
  standalone: false,
})
export class TimelineHistoryDialogComponent {
  @Input() title: string = 'App.StatusHistory.Labels.StatusHistory';
  @Input() highlightFirstItem: boolean = true;
  hideDot: boolean = false;
  events: Array<TimelineHistoryData> = [];
  statusMeta: Record<number, StatusMeta>;
  TABLE_DATA_TYPE = TableDataType;

  public historyDataSource: any;

  constructor(
    private dialogRef: MatDialogRef<TimelineHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { statusMeta: Record<number, StatusMeta>; events: Array<TimelineHistoryData> },
  ) {
    this.statusMeta = data.statusMeta;
    this.events = data.events;
    this.hideDot = this.events.length == 1;
    this.dialogRef.addPanelClass('dialog');
    this.dialogRef.updateSize('600px', 'auto');
  }

  closeDialog() {
    this.dialogRef.close();
  }

  // Get class for each status
  getStatusClass(id: number): string {
    return this.statusMeta[id]?.css ?? 'status-grey';
  }

  // Get mapped status
  getMappedStatus(id: number): string {
    return this.statusMeta[id]?.key ?? 'App.Status.unknown';
  }
}
